// Credit 不足提示 / Insufficient credit modal.

export function showInsufficientCreditModal(cost: number, current: number): void {
  const root = document.getElementById("credit-modal");
  if (!root) throw new Error("#credit-modal mount missing");
  root.hidden = false;
  root.innerHTML = `
    <div class="overlay"></div>
    <div class="modal">
      <h3>Insufficient Credit</h3>
      <p>Current balance: ${current}</p>
      <p>Required: ${cost}</p>
      <p>Please ask an administrator to add more Credit:</p>
      <a class="contact" target="_blank" rel="noopener"
         href="https://github.com/xyskywalker">https://github.com/xyskywalker</a>
      <button class="ack">Got it</button>
    </div>
  `;
  root.querySelector<HTMLButtonElement>(".ack")
    ?.addEventListener("click", () => { root.hidden = true; root.innerHTML = ""; });
}
